import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SnackBarService } from "../../service/snack.bar.service";

export interface DialogData {
limit : string,
rate: string
}

@Component({
  selector: 'financier-limit-dialog',
  templateUrl: 'financier-limit-dialog.html',
})
export class FinancierLimitDialog {
  formData : any;
  formGrp: FormGroup;

  result: DialogData = {
    limit: "",
    rate: ""
  };

  constructor(
    public dialogRef: MatDialogRef<FinancierLimitDialog>,
    private snackBarService: SnackBarService,
    @Inject(MAT_DIALOG_DATA) private dialogdData: DialogData
  ) 
  {
    this.formData = [this.dialogdData.limit, this.dialogdData.rate]
    this.initForm();
    this.setFormData();
  }

  private initForm() {
    this.formGrp = new FormGroup({
      financierLimit: new FormControl("", [Validators.min(1)]),
      interestRate: new FormControl("", [Validators.max(100)]),
    });
  }

  private setFormData() {
    let formcontrolName = this.formGrp.controls;
    formcontrolName.financierLimit.setValue(this.formData[0]);
    formcontrolName.interestRate.setValue(this.formData[1]);
  }

  save() {
    if (this.formGrp.invalid)
      return this.snackBarService.show("Please complete or correct the required field(s).")

    let data = {
      financierLimit: this.formGrp.controls.financierLimit.value,
      interestRate: this.formGrp.controls.interestRate.value

    }
    this.dialogRef.close(data);
  }


  close() {
    this.dialogRef.close();
  }
}